import { AnchorHTMLAttributes, MouseEvent } from 'react';
import classnames from 'classnames';
import { TMenuChoice } from '../AnchorOrButtonMenuChoice/AnchorOrButtonMenuChoice';
import useStyles from '../AnchorOrButtonMenuChoice/AnchorOrButtonMenuChoice.styles';

export type TAnchorMenuChoice = {
  /** Optional JSS class for further styling */
  className?: string;
  /** The label for the anchor element */
  label: string;
  /** Function run when the menu action is clicked. Required for button action menu element. */
  onClick?(event: MouseEvent<HTMLAnchorElement>, menuChoice: TMenuChoice): void;
  /** The URL that the hyperlink points to. If undefined, a button will be rendered for the menu action.
   * If passed, an anchor element will rendered for the menu action.
   */
  href: AnchorHTMLAttributes<HTMLAnchorElement>['href'];
  /** Attributes spread onto the anchor element */
  hrefOptions?: AnchorHTMLAttributes<HTMLAnchorElement>;
};

export type TAnchorMenuChoiceProps = TAnchorMenuChoice & {
  onClickMenuChoice(): void;
};

const AnchorMenuChoice = (props: TAnchorMenuChoiceProps) => {
  const { className, href, hrefOptions, label, onClick, onClickMenuChoice } = props;
  const classes = useStyles();
  return (
    <a
      key={label}
      className={classnames(classes.menuButton, className)}
      href={href}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...hrefOptions}
      onClick={(event) => {
        if (onClick) {
          onClick(event, props);
        }
        onClickMenuChoice();
      }}
    >
      {label}
    </a>
  );
};

export default AnchorMenuChoice;
